import { currentUserRoleAtom } from "@app/store/userStore";
import { Box } from "@design-system/Layout/Box";
import { useAtomValue } from "jotai";
import { type FC } from "react";
import { useObjectiveFilters } from "../../hooks/useObjectiveFilters";
import { FilterChips } from "../ObjectiveTable/FilterChips";

export const ObjectiveFilters: FC = () => {
    const isContributor = useAtomValue(currentUserRoleAtom).isContributor;
    const {
        selectedThemesIds,
        selectedSubthemesIds,
        selectedUserIds,
        themeSearchFilter,
        subthemeSearchFilter,
        ownerSearchFilter,
        setSelectedUserIds,
        setThemeSearchFilter,
        setSubthemeSearchFilter,
        setOwnerSearchFilter,
        handleThemeChange,
        handleSubthemeChange,
    } = useObjectiveFilters();

    return (
        <Box px="4" py="1">
            <FilterChips>
                {!isContributor && (
                    <FilterChips.AssigneeFilterChip
                        value={selectedUserIds}
                        onValueChange={setSelectedUserIds}
                        searchFilter={ownerSearchFilter}
                        onSearchFilterChange={setOwnerSearchFilter}
                    />
                )}
                <FilterChips.ThemeFilterChip
                    value={selectedThemesIds}
                    onValueChange={handleThemeChange}
                    searchFilter={themeSearchFilter}
                    onSearchFilterChange={setThemeSearchFilter}
                />
                <FilterChips.SubThemeFilterChip
                    value={selectedSubthemesIds}
                    onValueChange={handleSubthemeChange}
                    searchFilter={subthemeSearchFilter}
                    onSearchFilterChange={setSubthemeSearchFilter}
                />
            </FilterChips>
        </Box>
    );
};
